import 'twin.macro';
import { Classroom } from '@teetsh/app/src/types/classroom';
import { ArrowRightIcon } from '@heroicons/react/24/outline';
import Select from '@teetsh/app/src/components/Form/Select2';
import { replaceItemAtIndex } from '@teetsh/app/src/utils/listMethods';
import { PlusIcon } from '@heroicons/react/20/solid';
import { NoSymbolIcon } from '@heroicons/react/20/solid';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

export interface ClassroomMapping {
  from: string;
  to?: string;
}

interface Props {
  srcClassrooms: Classroom[];
  destClassrooms: Classroom[];
  value: ClassroomMapping[];
  onChange: (v: ClassroomMapping[]) => void;
  enableCreateClassroom?: boolean;
}

export const NO_COPY = 'NO_COPY';

export function ClassroomsMapping(props: Props) {
  const {
    value,
    srcClassrooms,
    destClassrooms,
    onChange,
    enableCreateClassroom,
  } = props;
  const { t } = useTranslation(['common']);
  return (
    <div tw="grid grid-cols-12 items-center gap-4">
      {value.map(({ from, to }, i) => (
        <Fragment key={from}>
          <div tw="col-span-3">
            {srcClassrooms.find(c => c.id === from)?.name}
          </div>
          <div tw="col-span-2 text-center">
            <ArrowRightIcon tw="h-6 w-6" />
          </div>
          <div tw="col-span-7">
            <Select<string | undefined>
              tw="bg-white"
              portal
              options={[
                ...destClassrooms.map(c => ({
                  value: c.id,
                  label: c.name,
                })),
                {
                  label: (
                    <div tw="flex items-center">
                      <NoSymbolIcon tw="h-5 w-5 mr-2" />
                      {t('common:classroomMapping.doNotCopy')}
                    </div>
                  ),
                  value: NO_COPY,
                },
                ...(enableCreateClassroom
                  ? [
                      {
                        label: (
                          <div tw="flex items-center">
                            <PlusIcon tw="h-5 w-5 mr-2" />
                            {t('common:classroomMapping.add')}
                          </div>
                        ),
                        value: undefined,
                      },
                    ]
                  : []),
              ]}
              value={to}
              onChange={classroomId =>
                onChange(
                  replaceItemAtIndex<ClassroomMapping>(
                    value,
                    { from, to: classroomId },
                    i,
                  ),
                )
              }
            />
          </div>
        </Fragment>
      ))}
    </div>
  );
}
